import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import api from '../api/axios';

export default function ProtectedRoute({ children }) {
  const [status, setStatus] = useState('checking'); // 'checking' | 'ok' | 'fail'

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (!token) { setStatus('fail'); return; }

    // Verify token is still valid against the server
    api.get('/auth/me')
      .then(() => setStatus('ok'))
      .catch(() => {
        // axios interceptor already tries refresh — if it still fails it clears
        // localStorage and redirects, but we handle it here too just in case
        localStorage.clear();
        setStatus('fail');
      });
  }, []);

  if (status === 'checking') {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        background: '#f5f5f5',
        flexDirection: 'column',
        gap: 12,
      }}>
        <div style={{
          width: 36,
          height: 36,
          border: '3px solid #e0e0e0',
          borderTop: '3px solid #6CA651',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        <span style={{ color: '#888', fontSize: 13 }}>Verifying session...</span>
      </div>
    );
  }

  return status === 'ok' ? children : <Navigate to="/login" replace />;
}
